async function processFiles(files, attachmentsBucketFolder, uploadFile) {
    if (!uploadFile) {
        return [];
    }
    const results = [];
    // We have to upload files one by one to not avoid concurrency issues
    // and don't let graphql to combine these requests into one call based on the common content type
    for (const file of files) {
        try {
            const url = await uploadFile({
                file,
                fileKey: attachmentsBucketFolder,
                hasAttachments: true,
            });
            if (url) {
                results.push({
                    url,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                });
            }
        }
        catch (error) {
            // not throwing an error as other files might have been uploaded successfully
            // and user should be able to manage them already
            console.error(error);
        }
    }
    return results;
}
export function getAttachmentsFromEditor({ files, attachmentsBucketFolder, uploadFile, }) {
    return processFiles(files ?? [], attachmentsBucketFolder, uploadFile);
}
